import React, { useEffect, useRef, useState } from "react";
import "../components/css/style.css";

const testimonials = [
  {
    name: "Astro Sanngita Jain",
    role: "Moon Magic Astrology",
    text: "Great experience with rhythmgrowthlab! They built a clean, modern, and fast website exactly how I wanted. Super responsive and easy to work with. Highly recommend!"
  },
  {
    name: "Unifits",
    role: "",
    text: "Amazing website design by Rhythmgrowthlab! He totally nailed the look and feel of our fashion brand UNIFITS. Super easy to work with and delivered exactly what we wanted!"
  },
  {
    name: "Depali K Jain",
    role: "Tarot Reader",
    text: "Working with Rhythmgrowthlab was a truly aligned experience. They created a beautiful, intuitive tarot website that perfectly reflects the calm, spiritual energy of my brand. Communication was effortless, deadlines were honored, and their support went above and beyond. I highly recommend them for soulful, high-quality web design. ✨🔮"
  },
  {
    name: "Ajay Fashion",
    role: "",
    text: "Working with Rhythmgrowthlab has been a game-changer for our social media presence. Their strategic approach and attention to detail helped us reach new heights in engagement and brand visibility."
  },
  {
    name: "Plix Media",
    role: "",
    text: "Arvind Kumar from Plix Media, It’s excellent experience with Rhythmfrowthlab, They leads my team and my business handle it very peaceful."
  },
  {
    name: "Dhruv",
    role: "Video Editor",
    text: "Working with RhythmgrowthLab transformed our approach to digital marketing. Every campaign was well-planned, optimized continuously, and focused on outcomes that truly mattered to our business."
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const [isVisible, setIsVisible] = useState({});

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.dataset.index]: true }));
          }
        });
      },
      { threshold: 0.6, rootMargin: "0px 0px -50px 0px" }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => 
        prev + 3 >= testimonials.length ? 0 : prev + 3
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const visibleTestimonials = testimonials.slice(currentIndex, currentIndex + 3);

  return (
    <section className="success-section" ref={sectionRef}>
      <div className="blob-container">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>

      <div className="success-container">
        <div className="success-header fade-in-up">
          <span className="success-tag">TESTIMONIALS</span>
          <h2>Our Agency's Success Stories</h2>
          <p>
            Explore how we empower businesses and founders to achieve measurable growth through proven success stories and client experiences.
          </p>
        </div>

        <div className="slider-container">
          <div className="success-grid">
            {visibleTestimonials.map((item, index) => {
              const actualIndex = currentIndex + index;
              return (
                <div 
                  className={`success-card fade-in-up ${
                    isVisible[actualIndex] ? 'visible' : ''
                  }`}
                  key={actualIndex}
                  ref={(el) => (cardsRef.current[actualIndex] = el)}
                  data-index={actualIndex}
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  <div className="quote-icon">“</div>

                  <p className="success-text">{item.text}</p>

                  <div className="success-user">
                    <div>
                      <h4>{item.name}</h4>
                      <span>{item.role}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}